<template>
  <b-container v-if="$parent.profileUser && messagingOptions !== null">
    <b-row align-h="center">
      <b-col cols="12" md="8" lg="6" class="py-3">
        <p class="lead pb-3">{{ $t("profile:lead-messaging-options") }}</p>
        <b-form @submit.prevent="saveMessagingOptions">
          <b-row>
            <b-col>
              <b-form-checkbox
                v-model="messagingOptions.wellbeingCheckUps"
                name="wellbeingCheckUpsOptIn"
                :unchecked-value="false">
                {{ $t("profile:label-messaging-options-wellbeing-checkups") }}
              </b-form-checkbox>
              <p>
                <small>
                  {{$t("profile:description-messaging-options-wellbeing-checkups")}}
                </small>
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-checkbox
                v-model="messagingOptions.personalReports"
                name="personalReportsOptIn"
                :unchecked-value="false">
                {{ $t("profile:label-messaging-options-personal-reports") }}
              </b-form-checkbox>
              <p>
                <small>
                  {{$t("profile:description-messaging-options-personal-reports")}}
                </small>
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-checkbox
                v-model="messagingOptions.workCommunityReports"
                name="workCommunityReportsOptIn"
                :unchecked-value="false">
                {{$t("profile:label-messaging-options-work-community-reports")}}
              </b-form-checkbox>
              <p>
                <small>
                  {{$t("profile:description-messaging-options-work-community-reports")}}
                </small>
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-checkbox
                v-model="messagingOptions.emooterUpdates"
                name="emooterUpdatesOptIn"
                :unchecked-value="false">
                {{ $t("profile:label-messaging-options-bubblo+-updates") }}
              </b-form-checkbox>
              <p>
                <small>
                  {{$t("profile:description-messaging-options-bubblo+-updates")}}
                </small>
              </p>
            </b-col>
          </b-row>
          <b-form-group class="text-right">
            <b-button
              id="submit-button_save-messaging-options"
              type="submit"
              variant="success"
              :disabled="!dirty || loading.loading"
              :class="{ loading: loading.loading }">
              {{ $t("common:save") }}
            </b-button>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      dirty: false,
      loading: {
        loading: false,
        success: null,
        error: null
      },
      messagingOptions: null
    }
  },
  methods: {
    makeToast (append = false) {
      this.$bvToast.toast(this.$t('common:changes-saved'), {
        toaster: 'b-toaster-top-center',
        variant: 'success',
        noCloseButton: true,
        autoHideDelay: 3500,
        appendToast: append
      })
    },
    saveMessagingOptions () {
      this.loading.loading = true
      this.loading.success = null
      this.loading.failure = null
      this.axios
        .post('/users/update/messaging-options', this.messagingOptions)
        .then((response) => {
          this.loading.loading = false
          this.loading.success = true
          this.loading.failure = false
          this.dirty = false
          this.makeToast()
        })
        .catch(() => {
          this.loading.loading = false
          this.loading.success = false
          this.loading.failure = true
        })
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  watch: {
    messagingOptions: {
      deep: true,
      handler () {
        this.dirty = true
      }
    },
    user: {
      immediate: true,
      handler (user) {
        if (user && user.userSettings) {
          this.messagingOptions = user.userSettings.messagingOptions
        }
      }
    }
  }
}
</script>
